import { getAuthSession } from "lib/apis/auth";
import type { AuthSessionResponse } from "lib/apis/auth";

import { clearAccessToken, getAccessToken } from "./authToken";

export async function loadSession(): Promise<AuthSessionResponse | null> {
  if (!getAccessToken()) {
    return null;
  }

  try {
    return await getAuthSession();
  } catch (_error) {
    clearAccessToken();
    return null;
  }
}
